import React from "react";

const Savingsclient = () => {
  return (
    <section class="bg-dark-gray">
      <div class="container">
        <div class="row justify-content-center mb-5 sm-mb-30px">
          <div
            class="col-xl-6 col-lg-8 col-md-10 text-center"
            data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'
          >
            <h3 class="text-white mb-0 fw-600">
              Serving our clients across the diverse industries.
            </h3>
          </div>
        </div>
        <div
          class="row row-cols-2 row-cols-md-4 row-cols-lg-6 g-0"
          data-anime='{ "el": "childs", "translateY": [15, 0], "opacity": [0,1], "duration": 300, "delay":0, "staggervalue": 100, "easing": "easeOutQuad" }'
        >
          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconbox hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden    border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Microphone-4 icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Publishing
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconbox hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden   border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Basket-Coins icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Finance
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconbox hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden    border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Bee icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Sciences
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconbox hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden   border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Management icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Consultant
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconbox hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden   border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-French-Fries icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Food
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxbottom hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden  border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Road-3 icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Travel
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxright hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden   border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Cow icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Dairy
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxright hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden  border-1  sm-border-end-0  border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Diamond icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Jewellery
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxright hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden  sm-border-end-0 border-1  border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Drop icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Energy
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxright hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden border-1 sm-border-end-0  border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Environmental-3 icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Farming
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box niceIconboxright hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden   sm-border-end-0 border-1 border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Gear icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Industries
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>

          <div class="col icon-with-text-style-04 transition-inner-all">
            <div class="feature-box hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden border-1 border-color-transparent-white-light border-color-transparent-on-hover">
              <div class="feature-box-icon">
                <i class="line-icon-Environmental-3 icon-extra-large text-white mb-15px"></i>
              </div>
              <div class="feature-box-content">
                <span class="d-inline-block text-white fw-600 fs-14 text-uppercase">
                  Events
                </span>
              </div>
              <div class="feature-box-overlay bg-base-color"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Savingsclient;
